import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IUserInterfaceState } from "../../../../features/ui/store/ui.reducer";
import { createEmptyError, IError } from "../../../../redux/actions/errorHandlingAction";
import { UserData } from "../../types/user-data.interface";
import { createUserData } from "../../types/user-data.functions";
import { LoginView } from "../login-view/login-view.component";
import * as userStore from "../../../../features/user/store/user.store";

export const Login = () => {
  const { loading: uiLoading, errors: uiErrors } = useSelector(
    (state: IUserInterfaceState) => state.UI
  );

  const [userDataValues, setUserDataValues] = useState<UserData>(createUserData());
  const [rememberMe, setRememberMe] = useState(false);

  const [errors, setErrors] = useState<IError>(createEmptyError());
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    if (uiErrors) {
      setErrors(uiErrors);
    }
    setLoading(uiLoading);
  }, [uiErrors, uiLoading]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setLoading(true);

    userStore.login(createUserData(userDataValues.email, userDataValues.password));
  };

  const handleChange = (e: any) => {
    e.persist();
    setUserDataValues((values: any) => ({
      ...values,
      [e.target.name]: e.target.value,
    }));
  };

  const handleRememberMe = (e: any) => setRememberMe(e.target.checked);
  const handleForgotPassword = (e: any) => history.push("/forgot-password");

  return (
    <LoginView
      userDataValues={userDataValues}
      errors={errors}
      loading={loading}
      rememberMe={rememberMe}
      onChange={handleChange}
      onRememberMe={handleRememberMe}
      onSubmit={handleSubmit}
      onForgotPassword={handleForgotPassword}
    />
  );
};
